var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.59,
    cy: 55.92,
    r: 25.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.59,
    cy: 143.78,
    r: 13.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 165.08,
    cy: 143.78,
    r: 13.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "51.95 129.06 51.95 106.35 108.57 119.54 108.57 193.92 51.95 180.72 51.95 158.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "165.23 157.39 165.23 180.72 108.62 193.92 108.62 119.54 165.23 106.35 165.23 130.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.83,108.36A27.64,27.64,0,0,0,124,94.66H93.62a27.64,27.64,0,0,0-24.26,14.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReader);
export default __webpack_public_path__ + "static/media/READER.7d440ef6f22b810461fa1e17731d7dcd.svg";
export { ForwardRef as ReactComponent };